jQuery(function($)
{
    var { show } = orion;
    var { hide } = orion;
    var $container = $('#specials, #content-special, #pds-landingpage');
    var $productOverlayTrigger = $('.js-product-overlay-trigger');

    if ($container.length === 0)
    {
        return;
    }

    function handleClickProductOverlayTrigger()
    {
        var $this = $(this);
        var $productOverlay = $this.closest('.item').find('.product-overlay');
        var $iconVariation = $('.fa-info-circle', $this);
        var $iconClose = $('.fa-close', $this);

        if ($productOverlay.hasClass('hidden'))
        {
            show($productOverlay);
            hide($iconVariation);
            show($iconClose);
        }
        else
        {
            hide($productOverlay);
            hide($iconClose);
            show($iconVariation);
        }
    }

    // Overlay: Theme Worlds referred from Google
    function showThemeWorldsReferral()
    {
        if (!(sessionStorage.getItem('themeWorldsOverlayShown')))
        {
            $('#trigger-overlay-theme-worlds').trigger('click');
        }
        $('.js-theme-worlds-link').on('click', () =>
        {
            sessionStorage.setItem('themeWorldsOverlayShown', true);
        });
    }

    // Trigger: Theme Worlds referred from Google
    if (document.referrer.indexOf('google') != -1 && !$('body').hasClass('authorized'))
    {
        showThemeWorldsReferral();
    }

    $productOverlayTrigger.on('click', handleClickProductOverlayTrigger);
});
